/**
 * HumanLoader — Bloco 4 (Fase B)
 *
 * Rotating humanised loading messages while long ops run
 * (candidate analysis, TSE searches, dossier fetch).
 *
 * Usage:
 *   <HumanLoader active={loading} />
 */
import React, { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";

const DEFAULT_MESSAGES = [
  "Consultando dados oficiais do TSE...",
  "Verificando o histórico público...",
  "Analisando bens declarados...",
  "Checando processos e pendências...",
  "Quase lá! Preparando o resumo...",
];

export function HumanLoader({ active = true, messages = DEFAULT_MESSAGES, intervalMs = 2500, className = "" }) {
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    if (!active) return undefined;
    setIdx(0);
    const id = setInterval(() => setIdx((i) => (i + 1) % messages.length), intervalMs);
    return () => clearInterval(id);
  }, [active, messages, intervalMs]);

  if (!active) return null;

  return (
    <div
      className={`flex items-center gap-3 text-slate-600 ${className}`}
      data-testid="human-loader"
      role="status"
      aria-live="polite"
    >
      <Loader2 className="w-5 h-5 animate-spin text-[#006030]" />
      <span className="text-sm font-medium" data-testid="human-loader-message">
        {messages[idx]}
      </span>
    </div>
  );
}

export default HumanLoader;
